import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import IdentityPage from './pages/IdentityPage';
import SecurityPage from './pages/SecurityPage';
import AppsPage from './pages/AppsPage';
import SupportPage from './pages/SupportPage';
import OAuthCallbackPage from './pages/OAuthCallbackPage';
import NotificationsPage from './pages/NotificationsPage';

type ProtectedRouteProps = { children: JSX.Element };

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="full-centre">Loading Gate.haus…</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
};

const App = () => (
  <Routes>
    <Route path="/" element={<Navigate to="/dashboard" replace />} />
    <Route path="/login" element={<LoginPage />} />
    <Route path="/register" element={<RegisterPage />} />
    <Route
      path="/dashboard"
      element={
        <ProtectedRoute>
          <DashboardPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/identity"
      element={
        <ProtectedRoute>
          <IdentityPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/security"
      element={
        <ProtectedRoute>
          <SecurityPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/apps"
      element={
        <ProtectedRoute>
          <AppsPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/support"
      element={
        <ProtectedRoute>
          <SupportPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/notifications"
      element={
        <ProtectedRoute>
          <NotificationsPage />
        </ProtectedRoute>
      }
    />
    <Route path="/oauth/callback" element={<OAuthCallbackPage />} />
    <Route path="*" element={<Navigate to="/dashboard" replace />} />
  </Routes>
);

export default App;
